var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-formio";
import formatFormioJSON from "../../utils/FormatFormioJSON";
import handleCustomEvent from "../../utils/HandleCustomEvent";
import { ModalPicker } from "../common/ModalPicker";
import FormContext from "../../contexts/formContext/form-context";
import SubmissionContext from "../../contexts/submissionContext/submission-context";
import FormState from "../../contexts/formContext/FormState";
import SubmissionState from "../../contexts/submissionContext/SubmissionState";
import ToastMessage from "../common/ToastMessage";
import { submissionGETdata, submissionPOSTdata, submissionPUTdata, } from "../../services/SubmissionService";
var TsfFormioForm = function (props) {
    var _a = useState({}), submissionData = _a[0], setSubmissionData = _a[1];
    var form = props.form;
    useEffect(function () {
        if (form && form.properties !== null) {
            var _a = form.properties, isInit = _a.isInit, requestType = _a.requestType, endpoint = _a.endpoint, requestBody = _a.requestBody;
            if (form && form.properties && isInit && requestType === "get") {
                submissionGETdata(endpoint, setSubmissionData);
            }
            else if (isInit && requestType === "post") {
                submissionPOSTdata(endpoint, setSubmissionData, requestBody);
            }
            else if (isInit && requestType === "put") {
                submissionPUTdata(endpoint, setSubmissionData, requestBody);
            }
        }
    }, [form]);
    return (React.createElement(SubmissionState, null,
        React.createElement(FormState, null,
            React.createElement(FormioForm, __assign({ submission: submissionData }, props)))));
};
var FormioForm = function (props) {
    var form = props.form, submission = props.submission, onCustomEvent = props.onCustomEvent, other = __rest(props, ["form", "submission", "onCustomEvent"]);
    var customForm = form;
    var _a = useContext(FormContext), formioForm = _a.form, updateForm = _a.updateForm;
    var _b = useContext(SubmissionContext), submissionData = _b.submission, updateSubmission = _b.updateSubmission, resetSubmission = _b.resetSubmission;
    useEffect(function () {
        if (formioForm !== form) {
            resetSubmission();
        }
    }, [form]);
    useEffect(function () {
        if (submission === null || submission === void 0 ? void 0 : submission.data) {
            updateSubmission(submission.data);
        }
        updateForm(customForm);
    }, [customForm, submission]);
    return (React.createElement("div", null,
        React.createElement(Form, __assign({ form: formatFormioJSON(formioForm === null || formioForm === void 0 ? void 0 : formioForm.components), submission: submissionData, 
            // onChange={({ data, changed }) => {
            //   if (changed) {
            //     updateSubmission(data);
            //   }
            // }}
            onCustomEvent: function (event) {
                handleCustomEvent(event, customForm, onCustomEvent, updateSubmission);
            } }, other)),
        React.createElement(ModalPicker, null),
        React.createElement(ToastMessage, null)));
};
export default TsfFormioForm;
//# sourceMappingURL=index.js.map